import { render, staticRenderFns } from "./StatusCreate.vue?vue&type=template&id=0a3f90f8"
import script from "./StatusCreate.vue?vue&type=script&lang=js"
export * from "./StatusCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports